export default {
    chart: {
        root: 'relative'
    }
}

